import React from "react";
import classNames from "classnames";

import { ToggleArrow } from "@common/toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function Section({
  header,
  list,
  isHeaderToggleDisabled = false,
  isOpen: open = false,
}: Props) {
  const [isOpen, setIsOpen] = React.useState(open);

  React.useEffect(() => {
    open !== isOpen && setIsOpen(open);
  }, [open]);

  return (
    <div className={classNames(styles.section, { [styles.open]: isOpen })}>
      <div
        className={styles.header}
        onClick={!isHeaderToggleDisabled ? () => setIsOpen(!isOpen) : undefined}
      >
        {header}
        {!isHeaderToggleDisabled && (
          <div
            className={styles.iconBox}
            onClick={
              isHeaderToggleDisabled ? () => setIsOpen(!isOpen) : undefined
            }
          >
            <ToggleArrow className={styles.icon} />
          </div>
        )}
      </div>
      {isOpen && <div className={styles.list}>{list}</div>}
    </div>
  );
}

export { Section };
